import Button from "@mui/material/Button";
import { Box, Modal, Typography } from "@mui/material";
import AccentureIcon from "assets/AccentureIcon";
import { CustomHistoryModalContainer } from "../chat.styled";

export default function DeleteHistoryItemModal({openModal, handleModalClose, handleDelete}) {
  return (
    // Delete Confirmation Modal
    <CustomHistoryModalContainer
      open={openModal}
      onClose={handleModalClose}
      aria-labelledby="delete-modal"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 300,
          boxShadow: 24,
          textAlign: "center",
          zIndex: -1
        }}
        className="modal-container px-3 py-6 rounded-xl border-slate-700 transition-colors"
      >
        <Box sx={{ display: "flex", justifyContent: "center", m: 2 }}>
          <AccentureIcon />
        </Box>
        <Typography
          sx={{ marginBottom: 2, fontWeight: "bold" }}
          variant="body1"
          gutterBottom
        >
          Delete Chat
        </Typography>
        <Typography variant="caption" gutterBottom>
          Once deleted, conversations cannot be restored.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "space-evenly", mt: 2 }}>
          <Button onClick={handleModalClose} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleDelete} variant="outlined" color="error">
            Delete
          </Button>
        </Box>
      </Box>
    </CustomHistoryModalContainer>
  );
}
